var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/ResourcesMenu.js",
  _this = this;
import React, { useContext } from 'react';
import { t } from '@sm/intl';
import NavSubmenuCopy from '../../copy/NavSubmenuCopy';
import Menu from './components/Menu.js';
import SubMenu from './components/SubMenu';
import SubMenuBody from './components/SubMenuBody.js';
import BottomLinkWrapper from './components/BottomLinkWrapper.js';
import SubMenuItem from './components/SubMenuItem.js';
import Column from './components/Column.js';
import BottomLink from './components/BottomLink.js';
import SMHeaderContext from '../../SMHeaderContext';
import { exploreSurveyTemplates, resources, blog, helpCenter, resourcesMenu } from '../../config/linkInfo';
export var ResourcesMenu = function ResourcesMenu() {
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  var key = 'Resources';
  var subMenuTitle = t(NavSubmenuCopy.RESOURCES_TITLE);
  return /*#__PURE__*/React.createElement(Menu, Object.assign({
    menuKey: key
  }, resourcesMenu(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SubMenu, {
    submenuKey: key,
    title: subMenuTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SubMenuBody, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, lang === 'en' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, resources(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, blog(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, helpCenter(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, blog(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, helpCenter(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 17
    }
  }))))), lang === 'en' ? /*#__PURE__*/React.createElement(BottomLinkWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(BottomLink, Object.assign({}, exploreSurveyTemplates(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  }))) : null));
};
export default ResourcesMenu;
//# sourceMappingURL=ResourcesMenu.js.map